import { useState, useCallback } from 'react';
import { pagosFacturasAPI } from '../services/pagosFacturasAPI';

const FILTROS_INICIALES = {
  mes: null,
  anio: null,
  entidadFacturacion: '',
  idObraSocial: '',
  estadoPago: '',
};

export const usePagosFacturasOS = () => {
  const [facturas, setFacturas] = useState([]);
  const [totalFacturas, setTotalFacturas] = useState(0);
  const [montoTotal, setMontoTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtros, setFiltros] = useState(FILTROS_INICIALES);

  const buscarFacturas = useCallback(async (filtrosOverride, pageOverride) => {
    const filtrosActuales = filtrosOverride || filtros;
    const paginaActual = pageOverride || page;

    setLoading(true);
    setError(null);

    try {
      const params = { page: paginaActual, pageSize: 50 };

      if (filtrosActuales.mes) params.mes = filtrosActuales.mes;
      if (filtrosActuales.anio) params.anio = filtrosActuales.anio;
      if (filtrosActuales.entidadFacturacion) params.entidadFacturacion = filtrosActuales.entidadFacturacion;
      if (filtrosActuales.idObraSocial) params.idObraSocial = filtrosActuales.idObraSocial;
      if (filtrosActuales.estadoPago) params.estadoPago = filtrosActuales.estadoPago;

      const data = await pagosFacturasAPI.listarFacturas(params);

      setFacturas(data.items || []);
      setTotalFacturas(data.totalFacturas || 0);
      setMontoTotal(data.montoTotal || 0);
      setPage(data.page || 1);
      setTotalPages(data.totalPages || 1);
    } catch (err) {
      console.error('Error al cargar facturas:', err);
      setError('Error al cargar las facturas');
    } finally {
      setLoading(false);
    }
  }, [filtros, page]);

  const cambiarFiltros = useCallback((nuevosFiltros) => {
    const filtrosActualizados = { ...filtros, ...nuevosFiltros };
    setFiltros(filtrosActualizados);
    setPage(1);
    buscarFacturas(filtrosActualizados, 1);
  }, [filtros, buscarFacturas]);

  const cambiarPagina = useCallback((nuevaPagina) => {
    setPage(nuevaPagina);
    buscarFacturas(filtros, nuevaPagina);
  }, [filtros, buscarFacturas]);

  const marcarPagada = useCallback(async (facturaId, montoFactura) => {
    // Actualización optimista: si filtramos por IMPAGA, remover la factura del listado
    if (filtros.estadoPago === 'IMPAGA') {
      setFacturas(prev => prev.filter(f => f.id !== facturaId));
      setTotalFacturas(prev => prev - 1);
      setMontoTotal(prev => prev - montoFactura);
    } else {
      // Si no filtramos por IMPAGA, actualizar el estado en el listado
      setFacturas(prev =>
        prev.map(f => f.id === facturaId ? { ...f, estadoPago: 'ABONADA' } : f)
      );
    }

    // La llamada real se hace desde el componente que adjunta la constancia,
    // aquí solo manejamos la actualización optimista de la grilla
    return { success: true };
  }, [filtros.estadoPago]);

  return {
    facturas,
    totalFacturas,
    montoTotal,
    page,
    totalPages,
    loading,
    error,
    filtros,
    buscarFacturas,
    cambiarFiltros,
    cambiarPagina,
    marcarPagada,
  };
};
